import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { SignupPage } from './components/SignupPage';
import { ResetPasswordPage } from './components/ResetPasswordPage';
import { CardLinkPage } from './components/CardLinkPage';
import reportWebVitals from './reportWebVitals';
// DEV HARNESS: /__mobile mounts the full app on an in-memory fixture backend (no login) so the
// authed CRM can be driven at phone width and in the iOS Simulator. See src/dev/AppHarness.js.
//
// The import() MUST sit inside an `if` whose condition webpack can fold at build time. With
// DefinePlugin substituting NODE_ENV, webpack never walks this branch in a production build, so
// no harness chunk is emitted at all. (A ternary reading a precomputed const does not fold: the
// earlier version shipped a 14.6 kB fixture chunk to the live site.)
let harnessEl = null;
if (process.env.NODE_ENV !== 'production' && /^\/__mobile\/?$/.test(window.location.pathname)) {
  const AppHarness = React.lazy(() => import('./dev/AppHarness').then(m => ({ default: m.AppHarness })));
  harnessEl = <React.Suspense fallback={null}><AppHarness /></React.Suspense>;
}

// PUBLIC route: /signup/<org-slug> renders the standalone client-onboarding page
// OUTSIDE the authed CRM (no login gate, no app data). Everything else = the app.
const signupMatch = window.location.pathname.match(/^\/signup\/([a-z0-9-]+)\/?$/i);
// PUBLIC route: /reset-password renders the standalone "set a new password" page
// OUTSIDE the authed CRM. Serves both forgot-password and tech set-password
// (the Supabase recovery link lands here with the token in the URL hash).
const resetMatch = window.location.pathname.match(/^\/reset-password\/?$/i);
// PUBLIC route: /c/<code> — the short "add a card" link an operator texts a customer (CardLinkPage,
// public-card-link, sql/090). No login; the code is the only credential and lives 24 h.
const cardLinkMatch = window.location.pathname.match(/^\/c\/([A-Za-z0-9]{6,12})\/?$/);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {harnessEl
      || (signupMatch ? <SignupPage slug={signupMatch[1].toLowerCase()} />
      : resetMatch ? <ResetPasswordPage />
      : cardLinkMatch ? <CardLinkPage code={cardLinkMatch[1]} />
      : <App />)}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
